import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IssueRowVm } from '../../models/issue-view';

// The vehicle accordion supplies the container. The shared detail owns all Issue content.
@Component({
  selector: 'app-issue-card-expanded',
  templateUrl: './issue-card-expanded.component.html',
  styleUrls: ['./issue-card-expanded.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssueCardExpandedComponent {
  @Input() issueId!: string;
  @Input() assetId!: string;
  @Input() assetGroups: any[] = [];
  @Input() seed!: IssueRowVm;
  @Input() canMaintain = false;

  @Output() collapse = new EventEmitter<void>();
}